/**
 * Note: in Browser when we reload the gallery screen the param is not of type string[] but of type string (comma separated urls).
 * Thus we need to convert sting to string[]
 */
export const toStringArray = (
  input: string | string[] | undefined
): string[] => {
  if (Array.isArray(input)) return input;
  if (typeof input === 'string') {
    return input
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
  }
  return [];
};
